import React from 'react'
import {Alert, Button, Container, FormGroup, FormLabel, FormControl, FormCheck, Row, Col, Card} from 'react-bootstrap'
import StyledSelect from "../../components/StyledSelect";
import {BsBoxArrowUpRight, BsDownload, BsExclamationCircleFill, BsInfoCircleFill} from "react-icons/bs";
import './Referral.css'
import SendReferralDialog from './SendReferralDialog';
import ResetReferralDialog from "./ResetReferralDialog";
import ClinicInfoDialog from './ClinicInfoDialog'
import {format} from 'date-fns';
import {validateSwedishPersonalId} from "../../components/Helpers";

import "react-datepicker/dist/react-datepicker.css";


const Referral = ({referral,
                      careUnits, selectedCareUnit, opticianShops, selectedOpticianShop, opticianUsers, isClinicInfoDialogOpen,
                      isResetDialogOpen, isSendDialogOpen, sendReferralError, validationErrors,
                      openClinicInfoDialog, openResetDialog, openSendDialog, closeDialogs, setValidationErrors,
                      updateReferralValue, fileURL, fileCreatedDate, loggedInUser,
                      resetReferral, sendReferral}) => {

    const isReadOnly = () => {
        return fileURL !== null;
    }

    const availableCareUnits = (careUnits || []).filter(org =>
        !selectedOpticianShop?.careUnitOrganizationIds?.length ||
        selectedOpticianShop.careUnitOrganizationIds.includes(org.organizationId)
    );

    // For person number validation
    const isValidAtPositionIndex = (c, positionIndex) => {
        // console.log('isValidAtPositionIndex', c , positionIndex)
        if (positionIndex === 8) {
            if ('0123456789-'.indexOf(c) !== -1) {
                // Is a number or -
                return true;
            }
        } else {
            if ('0123456789'.indexOf(c) !== -1) {
                // Is a number
                return true;
            }
        }
        return false;
    }

    const handlePersonNoChange = (e) => {
        if (e.target.value && e.target.value.length > 0) {
            if (!isValidAtPositionIndex(e.target.value.charAt(e.target.value.length-1), e.target.value.length-1)) {
                // disregard the change if the last character is not a number or a - if the length is nine
                console.log('out1')
                return
            }
        }

        if (e.target.value && e.target.value.length===9){
            if (e.target.value && referral.patientPersonalId && e.target.value.length>referral.patientPersonalId.length) {
                // on addition
                // if we add something else than a '-' (i.e. a number), also add the '-' automatically
                if (e.target.value.charAt(8) !== '-') {
                    e.target.value = e.target.value.substring(0, 8) + '-' + e.target.value.charAt(8)
                }
            } else {
                // on deletion
                // do nothing, just let any character be deleted normally
            }
        }

        handleChange(e);
    }

    const handleNumericValueChange = (e) => {
        let val = e.target.value;
        if (val && val.length>0) {
            if (val && val.length===1) {
                if ('0123456789.,+-'.indexOf(val.charAt(0)) === -1) {
                    return;
                }
            } else {
                let adjustedVal = val.replace(',', '.');
                if (isNaN(adjustedVal)) {
                    return;
                }
            }
        }
        handleChange(e);
    }

    const handleChange = (e) => {
        // e.stopPropagation();
        // e.preventDefault();
        const fieldName = e.target.id === '' ? e.target.name : e.target.id;
        const fieldValue = e.target.value;
        const fieldType = e.target.type;
        if (fieldType === 'radio') {
            updateReferralValue(fieldName, fieldValue==='on');
        } else {
            updateReferralValue(fieldName, fieldValue);
        }
    }

    // const handleDateChange = (value, formattedValue) =>{
    //     updateReferralValue('lastExaminationDate', value);
    // }

    // const noValue = (val) => {
    //     return typeof val === "undefined" || val===null || val === "";
    // }

    // const noEyeValue = (eye) => {
    //     return noValue(eye.freeVisus)
    //     && noValue(eye.bestCorrectionSphere)
    //     && noValue(eye.bestCorrectionCyl)
    //     && noValue(eye.bestCorrectionAx)
    //     && noValue(eye.visus)
    //     && noValue(eye.visusAddStph)
    //     && noValue(eye.pressure)
    // }

    // const noExaminationValue = (examination) => {
    //     return noEyeValue(examination.left) && noEyeValue(examination.right);
    // }

    // const hasExaminationValues = (examination) => {
    //     return !noExaminationValue(examination);
    // }

    const validateReferral = () => {
        let errors = [];
        if (!referral.patientPersonalId
            || referral.patientPersonalId.length !== 13
            || !validateSwedishPersonalId(referral.patientPersonalId)
            || !(referral.patientPersonalId.substring(0,2) === "19"
                    || referral.patientPersonalId.substring(0,2) === "20")
        ) {
            errors.push("Inget eller felaktigt personnummer, använd formen ÅÅÅÅMMDD-NNNN");
            // console.log('errors', errors)
        }
        if (!referral.sender.organizationId) {
            errors.push("Ingen avsändare vald");
            // console.log('errors', errors)
        }
        if (!referral.receiver.organizationId) {
            errors.push("Ingen mottagare vald");
            // console.log('errors', errors)
        }
        if (!referral.opticianName || referral.opticianName.trim() === "") {
            errors.push("Vänligen välj giltigt namn på optiker");
        }
        if (!referral.patientName || referral.patientName.trim() === "") {
            errors.push("Vänligen välj giltigt namn på patient");
        }
        // if (hasExaminationValues(referral.resultLastExamination) && noValue(referral.lastExaminationDate)) {
        //     errors.push("Det finns värden i tidigare undersökning men datum är inte angivet");
        //     console.log('errors', errors)
        // }
        return errors;
    }

    const sendReferralClicked = (e) => {
        let errors = validateReferral();
        if (errors && errors.length>0) {
            setValidationErrors(errors);
        } else {
            sendReferral();
        }
    }

    const resetReferralClicked = (e) => {
        resetReferral();
    }

    return (
    <div className="Referral">
        {(isClinicInfoDialogOpen &&
            <ClinicInfoDialog
                clinicInfo={selectedCareUnit?.clinicInfo}
                careUnitName={selectedCareUnit?.name}
                onCloseClicked={closeDialogs}
            />)
        || (isResetDialogOpen &&
            <ResetReferralDialog />)
        || (isSendDialogOpen &&
            <SendReferralDialog />)
        }
        <Container id="referralMainGrid">
            <Row>
                {sendReferralError &&
                <Col xs={12} md={12} lg={12}>
                    <Alert variant="danger">{sendReferralError}</Alert>
                </Col>
                }
                {validationErrors && validationErrors.length>0 &&
                <Col xs={12} md={12} lg={12}>
                    <Alert variant="danger">
                        <b><BsExclamationCircleFill/> Fel upptäcktes i remissen, rätta dessa och testa att skicka igen</b>
                        <ul>
                        {
                            validationErrors.map((e, i)=> (<li key={"valerr-"+i}>{e}</li>))
                        }
                        </ul>
                    </Alert>
                </Col>
                }
                <Col xs={12} md={12} lg={2}>
                    <Alert variant="info">
                        <p><BsInfoCircleFill /> <strong>Instruktion</strong></p>
                    <p>
                        Fyll i uppgifterna i formuläret. Använd TAB-tangenterna för att förflytta dig
                        mellan fälten. När du är klar klickar du på Skicka.
                    </p>
                    <p>
                        Remissen skickas då direkt till mottagande enhet elektroniskt.
                        Du får direkt en bekräftelse på skärmen som du kan skriva ut och ge till kunden.
                    </p>
                    </Alert>
                </Col>
                <Col xs={12} md={12} lg={7} className={"fatBorderColumn"}>
                    {/*
                        PATIENTUPPGIFTER
                    */}
                    <Row>
                        <Col xs={12} md={12} lg={4}>
                            <FormGroup controlId={"patientPersonalId"}>
                                <FormLabel>Personnummer</FormLabel>
                                <FormControl type={"text"}
                                             required
                                             value={referral.patientPersonalId || ''}
                                             placeholder={"ÅÅÅÅMMDD-NNNN"}
                                             maxLength={13}
                                             disabled={isReadOnly()}
                                             onChange={handlePersonNoChange}
                                />
                                {/*<HelpBlock>Fyll i patientens personnummer på formatet ÅÅMMDD-NNNN</HelpBlock>*/}
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={12} lg={4}>

                            <FormGroup controlId={"patientName"}>
                                <FormLabel>Namn</FormLabel>
                                <FormControl type={"text"}
                                             value={referral.patientName || ''}
                                             placeholder={"Namn"}
                                             maxLength={64}
                                             disabled={isReadOnly()}
                                             onChange={handleChange}
                                />
                                {/*<HelpBlock>Fyll i patientens personnummer på formatet ÅÅMMDD-NNNN</HelpBlock>*/}
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={12} lg={4}>
                            <FormGroup controlId={"patientPhone"}>
                                <FormLabel>Telefonnummer</FormLabel>
                                <FormControl type={"text"}
                                             value={referral.patientPhone || ''}
                                             placeholder={"Telefonnummer"}
                                             maxLength={20}
                                             disabled={isReadOnly()}
                                             onChange={handleChange}
                                />
                                {/*<HelpBlock>Hjälptext</HelpBlock>*/}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={8}>
                            <FormGroup controlId={"interpreterNeeded"} >
                                <Row>
                                <Col xs={12} sm={12} md={12} lg={5}>
                                    <Row>
                                        <Col>
                                            <FormLabel >Krävs tolk?</FormLabel>{' '}
                                        </Col>
                                    </Row>
                                    <Row>
                                    <Col>
                                        <FormCheck inline>
                                            <FormCheck.Input type={'radio'}
                                                             onChange={handleChange}
                                                             disabled={isReadOnly()}
                                                             value={'on'}
                                                             checked={referral.interpreterNeeded === true} />
                                            <FormCheck.Label>JA</FormCheck.Label>
                                        </FormCheck>{' '}
                                        <FormCheck inline>
                                            <FormCheck.Input type={'radio'}
                                                             onChange={handleChange}
                                                             disabled={isReadOnly()}
                                                             value={'off'}
                                                             checked={referral.interpreterNeeded === false} />
                                            <FormCheck.Label>NEJ</FormCheck.Label>
                                        </FormCheck>{' '}
                                    </Col>
                                    </Row>
                                </Col>
                                <Col xs={12} sm={12} md={12} lg={7} xl={7}>
                                    <FormGroup controlId="interpreterLanguage">
                                        <FormLabel>Språk</FormLabel>
                                        <FormControl type={"text"}
                                                     value={referral.interpreterLanguage || ''}
                                                     placeholder={"Språk"}
                                                     maxLength={32}
                                                     disabled={isReadOnly()}
                                                     onChange={handleChange}
                                        />
                                        {/*<HelpBlock>Fyll i patientens personnummer på formatet ÅÅMMDD-NNNN</HelpBlock>*/}
                                    </FormGroup>
                                {/*<FormGroup controlId="interpreterLanguage">*/}
                                    {/*<FormControl as="select"*/}
                                                 {/*placeholder="Språk"*/}
                                                 {/*value={referral.interpreterLanguage || ""}*/}
                                                 {/*onChange={handleChange}*/}
                                                 {/*disabled={isReadOnly()}>*/}
                                        {/*<option value="">Språk</option>*/}
                                        {/*<option value="Arabiska">Arabiska</option>*/}
                                        {/*<option value="Finska">Finska</option>*/}
                                        {/*<option value="Samiska">Samiska</option>*/}
                                        {/*<option value="Annat">Annat</option>*/}
                                    {/*</FormControl>*/}
                                {/*</FormGroup>*/}
                                </Col>
                                </Row>
                            </FormGroup>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={4}>
                            <Row>
                            <FormGroup controlId={"photoSent"} name="photoSent">
                                <Col>
                                <FormLabel>Foto inskickat?</FormLabel>{' '}
                                </Col><Col>
                                <FormCheck inline>
                                    <FormCheck.Input type={'radio'}
                                                     value={'on'}
                                                     onChange={handleChange}
                                                     disabled={isReadOnly()}
                                                     checked={referral.photoSent === true}
                                    />
                                    <FormCheck.Label>JA</FormCheck.Label>
                                </FormCheck>
                                {' '}
                                <FormCheck inline>
                                    <FormCheck.Input type={'radio'}
                                                     value={'off'}
                                                     onChange={handleChange}
                                                     disabled={isReadOnly()}
                                                     checked={referral.photoSent === false}
                                    />
                                    <FormCheck.Label>NEJ</FormCheck.Label>
                                </FormCheck>{' '}
                                </Col>
                            </FormGroup>
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <FormGroup controlId={"question"}>
                                <FormLabel>Frågeställning (max 130 tecken)</FormLabel>
                                <FormControl type={"text"}
                                             value={referral.question || ''}
                                             placeholder={"Frågeställning"}
                                             maxLength={130}
                                             onChange={handleChange}
                                             disabled={isReadOnly()}
                                />
                                {/*<HelpBlock>Hjälptext</HelpBlock>*/}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <FormGroup controlId={"description"}>
                                <FormLabel>Detaljerad beskrivning av patientens besvär (max 1000 tecken)</FormLabel>
                                <FormControl //type={"text"}
                                             as="textarea"
                                             rows={7}
                                             value={referral.description || ''}
                                             placeholder={"Detaljerad beskrivning av patientens besvär"}
                                             maxLength={1000}
                                             onChange={handleChange}
                                             disabled={isReadOnly()}
                                />
                                {/*<HelpBlock>Hjälptext</HelpBlock>*/}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <FormGroup controlId={"duration"}>
                                <FormLabel>Hur länge har patienten haft sina besvär?</FormLabel>
                                <FormControl type={"text"}
                                    value={referral.duration || ''}
                                    placeholder={"Varaktighet"}
                                    maxLength={128}
                                    onChange={handleChange}
                                             disabled={isReadOnly()}
                                />
                                {/*<HelpBlock>Hjälptext</HelpBlock>*/}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <b>Resultat vid dagens undersökning</b>
                        </Col>
                    </Row>
                    <Row >
                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Card className={"panel-default"}>
                            <Row>


                        {/*TODAYS RESULT MATRIX*/}
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} className={'resultMatrix'}>

                            <Row className={"resultHeader"}>
                                <Col xs={1} sm={1} md={1} lg={1} xl={1}><b></b></Col>
                                <Col xs={11} sm={11} md={11} lg={11} xl={11}>
                                    <Row>
                                        <Col xs={2} sm={2} md={2} lg={2}>Fri</Col>
                                        <Col xs={5} sm={5} md={5} lg={5} className={'borderColumn'}>
                                            <Row className={"ps-2 pe-2"}>
                                                <Col xs={12} sm={12} md={12} lg={12}>Bästa korrektion</Col>
                                            </Row>
                                        </Col>
                                        <Col xs={5} sm={5} md={5} lg={5} className={'borderColumn'}>
                                            <Row className={"ps-2 pe-2"}>
                                                <Col xs={4} sm={4} md={4} lg={4}></Col>
                                                <Col xs={4} sm={4} md={4} lg={4}>Add</Col>
                                                <Col xs={4} sm={4} md={4} lg={4}></Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className={"resultHeader"}>
                                <Col xs={1} sm={1} md={1} lg={1}><b></b></Col>
                                <Col xs={11} sm={11} md={11} lg={11}>
                                    <Row>
                                        <Col xs={2} sm={2} md={2} lg={2}>Visus</Col>
                                        <Col xs={5} sm={5} md={5} lg={5} className={'borderColumn'}>
                                            <Row className={"ps-2 pe-2"}>
                                                <Col xs={4} sm={4} md={4} lg={4} >Sfär</Col>
                                                <Col xs={4} sm={4} md={4} lg={4}>Cyl</Col>
                                                <Col xs={4} sm={4} md={4} lg={4}>Ax</Col>
                                            </Row>
                                        </Col>
                                        <Col xs={5} md={5} lg={5} className={'borderColumn'}>
                                            <Row className={"ps-2 pe-2"}>
                                                <Col xs={4} sm={4} md={4} lg={4}>Visus</Col>
                                                <Col xs={4} sm={4} md={4} lg={4}>stph</Col>
                                                <Col xs={4} sm={4} md={4} lg={4}>Tryck</Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={1} sm={1} md={1} lg={1} className={"resultHeader"}><b>Höger</b></Col>
                                <Col xs={11} sm={11} md={11} lg={11}>
                                    <Row>
                                    <Col xs={2} sm={2} md={2} lg={2} className={"referralValueCol"}>
                                        <FormControl type={"text"}
                                                     id="resultToday.right.freeVisus"
                                                     value={referral.resultToday.right.freeVisus || ''}
                                                     maxLength={6}
                                                     onChange={handleNumericValueChange}
                                                     disabled={isReadOnly()}
                                        />
                                    </Col>
                                    <Col xs={5} sm={5} md={5} lg={5} className={'borderColumn referralValueCol'}>
                                        <Row className={"ps-2 pe-2"}>
                                            <Col xs={4} sm={4} md={4} lg={4} style={{padding:'1px'}}>
                                            <FormControl type={"text"}
                                                         id="resultToday.right.bestCorrectionSphere"
                                                         value={referral.resultToday.right.bestCorrectionSphere || ''}
                                                         maxLength={6}
                                                         onChange={handleNumericValueChange}
                                                         disabled={isReadOnly()}
                                                         />
                                        </Col>
                                            <Col xs={4} sm={4} md={4} lg={4} style={{padding:'1px'}}>
                                            <FormControl type={"text"}
                                                         id="resultToday.right.bestCorrectionCyl"
                                                         value={referral.resultToday.right.bestCorrectionCyl || ''}
                                                         maxLength={6}
                                                         onChange={handleNumericValueChange}
                                                         disabled={isReadOnly()}
                                            />
                                        </Col>
                                            <Col xs={4} sm={4} md={4} lg={4} style={{padding:'1px'}}>
                                            <FormControl type={"text"}
                                                         id="resultToday.right.bestCorrectionAx"
                                                         value={referral.resultToday.right.bestCorrectionAx || ''}
                                                         maxLength={6}
                                                         onChange={handleNumericValueChange}
                                                         disabled={isReadOnly()}
                                            />
                                        </Col>
                                        </Row>
                                    </Col>
                                    <Col xs={5} sm={5} md={5} lg={5} className={'borderColumn referralValueCol'}>
                                        <Row className={"ps-2 pe-2"}>
                                            <Col xs={4} sm={4} md={4} lg={4} style={{padding:'1px'}}>
                                            <FormControl type={"text"}
                                                         id="resultToday.right.visus"
                                                         value={referral.resultToday.right.visus || ''}
                                                         maxLength={6}
                                                         onChange={handleNumericValueChange}
                                                         disabled={isReadOnly()}
                                            />
                                        </Col>
                                            <Col xs={4} sm={4} md={4} lg={4} style={{padding:'1px'}}>
                                            <FormControl type={"text"}
                                                         id="resultToday.right.visusAddStph"
                                                         value={referral.resultToday.right.visusAddStph || ''}
                                                         maxLength={6}
                                                         onChange={handleNumericValueChange}
                                                         disabled={isReadOnly()}
                                            />
                                        </Col>
                                            <Col xs={4} sm={4} md={4} lg={4} style={{padding:'1px'}}>
                                            <FormControl type={"text"}
                                                         id="resultToday.right.pressure"
                                                         value={referral.resultToday.right.pressure || ''}
                                                         maxLength={6}
                                                         onChange={handleNumericValueChange}
                                                         disabled={isReadOnly()}
                                            />
                                        </Col>
                                        </Row>
                                    </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={1} sm={1} md={1} lg={1} className={"resultHeader"}><b>Vänster</b></Col>
                                <Col xs={11} sm={11} md={11} lg={11}>
                                    <Row>
                                    <Col xs={2} sm={2} md={2} lg={2} className={'referralValueCol'}>
                                        <FormControl type={"text"}
                                                     id="resultToday.left.freeVisus"
                                                     value={referral.resultToday.left.freeVisus || ''}
                                                     maxLength={6}
                                                     onChange={handleNumericValueChange}
                                                     disabled={isReadOnly()}
                                                    />
                                    </Col>
                                    <Col xs={5} sm={5} md={5} lg={5} className={'borderColumn referralValueCol'}>
                                        <Row className={"ps-2 pe-2"}>
                                            <Col xs={4} sm={4} md={4} lg={4} style={{padding:'1px'}}>
                                            <FormControl type={"text"}
                                                         id="resultToday.left.bestCorrectionSphere"
                                                         value={referral.resultToday.left.bestCorrectionSphere || ''}
                                                         maxLength={6}
                                                         onChange={handleNumericValueChange}
                                                         disabled={isReadOnly()}
                                            />
                                        </Col>
                                            <Col xs={4} sm={4} md={4} lg={4} style={{padding:'1px'}}>
                                            <FormControl type={"text"}
                                                         id="resultToday.left.bestCorrectionCyl"
                                                         value={referral.resultToday.left.bestCorrectionCyl || ''}
                                                         maxLength={6}
                                                         onChange={handleNumericValueChange}
                                                         disabled={isReadOnly()}
                                            />
                                        </Col>
                                            <Col xs={4} sm={4} md={4} lg={4} style={{padding:'1px'}}>
                                            <FormControl type={"text"}
                                                         id="resultToday.left.bestCorrectionAx"
                                                         value={referral.resultToday.left.bestCorrectionAx || ''}
                                                         maxLength={6}
                                                         onChange={handleNumericValueChange}
                                                         disabled={isReadOnly()}
                                            />
                                        </Col>
                                        </Row>
                                    </Col>
                                    <Col xs={5} sm={5} md={5} lg={5} className={'borderColumn referralValueCol'}>
                                        <Row className={"ps-2 pe-2"}>
                                            <Col xs={4} sm={4} md={4} lg={4} style={{padding:'1px'}}>
                                            <FormControl type={"text"}
                                                         id="resultToday.left.visus"
                                                         value={referral.resultToday.left.visus || ''}
                                                         maxLength={6}
                                                         onChange={handleNumericValueChange}
                                                         disabled={isReadOnly()}
                                            />
                                        </Col>
                                            <Col xs={4} sm={4} md={4} lg={4} style={{padding:'1px'}}>
                                            <FormControl type={"text"}
                                                         id="resultToday.left.visusAddStph"
                                                         value={referral.resultToday.left.visusAddStph || ''}
                                                         maxLength={6}
                                                         onChange={handleNumericValueChange}
                                                         disabled={isReadOnly()}
                                            />
                                        </Col>
                                            <Col xs={4} sm={4} md={4} lg={4} style={{padding:'1px'}}>
                                            <FormControl type={"text"}
                                                         id="resultToday.left.pressure"
                                                         value={referral.resultToday.left.pressure || ''}
                                                         maxLength={6}
                                                         onChange={handleNumericValueChange}
                                                         disabled={isReadOnly()}
                                            />
                                        </Col>
                                        </Row>
                                    </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>


                            </Row>
                            </Card>
                        </Col>
                        </Row>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <p>{' '}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <FormGroup controlId={"receivedCorrectionToday"} name={"receivedCorrectionToday"}>
                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <Row>
                                        <Col xs={6} sm={6} md={6} lg={5}>
                                <FormLabel>Erhållit korrektion vid dagens besök?</FormLabel>
                                        </Col>
                                        <Col xs={6} sm={6} md={6} lg={7}>
                                <FormCheck inline className={"pt-2 pb-3"}>
                                    <FormCheck.Input type={"radio"}
                                           value={'on'}
                                           checked={referral.receivedCorrectionToday === true}
                                           onChange={handleChange}
                                           disabled={isReadOnly()} />
                                    <FormCheck.Label>JA</FormCheck.Label>{' '}
                                </FormCheck>
                                <FormCheck inline>
                                    <FormCheck.Input type={"radio"}
                                           value={'off'}
                                           checked={referral.receivedCorrectionToday === false}
                                           onChange={handleChange}
                                           disabled={isReadOnly()}
                                    />
                                    <FormCheck.Label>NEJ</FormCheck.Label>{' '}
                                </FormCheck>
                                        </Col>
                                    </Row>
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={6} sm={6} md={6} lg={5}>
                            <FormLabel>Resultat vid föregående undersökning</FormLabel>
                            {/*<b>Resultat vid föregående undersökning</b>*/}
                        </Col>
                        <Col xs={6} sm={6} md={6} lg={7}>
                            {/*<FormGroup controlId="dob">*/}
                            {/*    <FormLabel>Select Date</FormLabel>*/}
                            <FormControl type="date" id="lastExaminationDate" onClick={(e)=>e.target.showPicker()} name="lastExaminationDate" placeholder="Datum ÅÅÅÅ-MM-DD"
                                         value={referral.lastExaminationDate || ''}
                                         onChange={handleChange}
                                         disabled={isReadOnly()} />
                            {/*</FormGroup>*/}


                            {/*<DatePicker id="referralLastExaminationDate"*/}
                            {/*            showIcon*/}
                            {/*            locale={"se"}*/}
                            {/*            selected={referral.lastExaminationDate || null}*/}
                            {/*            dateFormat={"yyyy-MM-dd"}*/}

                            {/*            placeholderText="Datum ÅÅÅÅ-MM-DD"*/}
                            {/*            // dayLabels={['Sön', 'Mån', 'Tis', 'Ons', 'Tors', 'Fre', 'Lör']}*/}
                            {/*            // monthLabels={['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli','Augusti', 'September', 'Oktober', 'November', 'December']}*/}
                            {/*            // calendarContainer={document.getElementById('datePickerCalendar')}*/}
                            {/*            onChange={handleDateChange}*/}
                            {/*            disabled={isReadOnly()}*/}
                            {/*/>*/}
                            {/*<div id={'datePickerCalendar'} className={"datePickerCalendar"}>&nbsp;</div>*/}
                            {/*<FormControl className={"date"}*/}
                            {/*             type={"text"}*/}
                            {/*             id="referralLastExaminationDate"*/}
                            {/*             value={referral.lastExaminationDate || ''}*/}
                            {/*             placeholder="Datum ÅÅÅÅMMDD"*/}
                            {/*             onChange={handleChange}*/}
                            {/*/>*/}
                        </Col>
                    </Row>
                    <Row>&nbsp;</Row>
                    <Row>
                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Card className={"panel-default"}>
                            <Row>
                        {/*LAST RESULT MATRIX*/}

                        <Col xs={12} sm={12} md={12} lg={12} className={'resultMatrix'}>

                            <Row className={"resultHeader"}>
                                <Col xs={1} sm={1} md={1} lg={1}><b></b></Col>
                                <Col xs={11} sm={11} md={11} lg={11}>
                                    <Row>
                                        <Col xs={2} sm={2} md={2} lg={2}>Fri</Col>
                                        <Col xs={5} sm={5} md={5} lg={5} className={'borderColumn'}>
                                            <Row className={"ps-2 pe-2"}>
                                                <Col xs={12} sm={12} md={12} lg={12}>Bästa korrektion</Col>
                                            </Row>
                                        </Col>
                                        <Col xs={5} sm={5} md={5} lg={5} className={'borderColumn'}>
                                            <Row className={"ps-2 pe-2"}>
                                                <Col xs={4} sm={4} md={4} lg={4}></Col>
                                                <Col xs={4} sm={4} md={4} lg={4}>Add</Col>
                                                <Col xs={4} sm={4} md={4} lg={4}></Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className={"resultHeader"}>
                                <Col xs={1} sm={1} md={1} lg={1}><b></b></Col>
                                <Col xs={11} sm={11} md={11} lg={11}>
                                    <Row>
                                        <Col xs={2} sm={2} md={2} lg={2}>Visus</Col>
                                        <Col xs={5} sm={5} md={5} lg={5} className={'borderColumn'}>
                                            <Row className={"ps-2 pe-2"}>
                                                <Col xs={4} sm={4} md={4} lg={4} >Sfär</Col>
                                                <Col xs={4} sm={4} md={4} lg={4}>Cyl</Col>
                                                <Col xs={4} sm={4} md={4} lg={4}>Ax</Col>
                                            </Row>
                                        </Col>
                                        <Col xs={5} sm={5} md={5} lg={5} className={'borderColumn'}>
                                            <Row className={"ps-2 pe-2"}>
                                                <Col xs={4} sm={4} md={4} lg={4}>Visus</Col>
                                                <Col xs={4} sm={4} md={4} lg={4}>stph</Col>
                                                <Col xs={4} sm={4} md={4} lg={4}>Tryck</Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={1} sm={1} md={1} lg={1} className={"resultHeader"}><b>Höger</b></Col>
                                <Col xs={11} sm={11} md={11} lg={11}>
                                    <Row>
                                        <Col xs={2} sm={2} md={2} lg={2} className={"referralValueCol"}>
                                            <FormControl type={"text"}
                                                         id="resultLastExamination.right.freeVisus"
                                                         value={referral.resultLastExamination.right.freeVisus || ''}
                                                         maxLength={6}
                                                         onChange={handleNumericValueChange}
                                                         disabled={isReadOnly()}
                                            />
                                        </Col>
                                    <Col xs={5} sm={5} md={5} lg={5} className={'borderColumn referralValueCol'}>
                                        <Row className={"ps-2 pe-2"}>
                                            <Col xs={4} sm={4} md={4} lg={4} style={{padding:'1px'}}>
                                                <FormControl type={"text"}
                                                             id="resultLastExamination.right.bestCorrectionSphere"
                                                             value={referral.resultLastExamination.right.bestCorrectionSphere || ''}
                                                             maxLength={6}
                                                             onChange={handleNumericValueChange}
                                                             disabled={isReadOnly()}
                                                />
                                            </Col>
                                            <Col xs={4} sm={4} md={4} lg={4} style={{padding:'1px'}}>
                                                <FormControl type={"text"}
                                                             id="resultLastExamination.right.bestCorrectionCyl"
                                                             value={referral.resultLastExamination.right.bestCorrectionCyl || ''}
                                                             maxLength={6}
                                                             onChange={handleNumericValueChange}
                                                             disabled={isReadOnly()}
                                                />
                                            </Col>
                                            <Col xs={4} sm={4} md={4} lg={4} style={{padding:'1px'}}>
                                                <FormControl type={"text"}
                                                             id="resultLastExamination.right.bestCorrectionAx"
                                                             value={referral.resultLastExamination.right.bestCorrectionAx || ''}
                                                             maxLength={6}
                                                             onChange={handleNumericValueChange}
                                                             disabled={isReadOnly()}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col xs={5} sm={5} md={5} lg={5} className={'borderColumn referralValueCol'}>
                                        <Row className={"ps-2 pe-2"}>
                                            <Col xs={4} sm={4} md={4} lg={4} style={{padding:'1px'}}>
                                                <FormControl type={"text"}
                                                             id="resultLastExamination.right.visus"
                                                             value={referral.resultLastExamination.right.visus || ''}
                                                             maxLength={6}
                                                             onChange={handleNumericValueChange}
                                                             disabled={isReadOnly()}
                                                />
                                            </Col>
                                            <Col xs={4} sm={4} md={4} lg={4} style={{padding:'1px'}}>
                                                <FormControl type={"text"}
                                                             id="resultLastExamination.right.visusAddStph"
                                                             value={referral.resultLastExamination.right.visusAddStph || ''}
                                                             maxLength={6}
                                                             onChange={handleNumericValueChange}
                                                             disabled={isReadOnly()}
                                                />
                                            </Col>
                                            <Col xs={4} sm={4} md={4} lg={4} style={{padding:'1px'}}>
                                                <FormControl type={"text"}
                                                             id="resultLastExamination.right.pressure"
                                                             value={referral.resultLastExamination.right.pressure || ''}
                                                             maxLength={6}
                                                             onChange={handleNumericValueChange}
                                                             disabled={isReadOnly()}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={1} sm={1} md={1} lg={1} className={"resultHeader"}><b>Vänster</b></Col>
                                <Col xs={11} sm={11} md={11} lg={11}>
                                    <Row>
                                    <Col xs={2} sm={2} md={2} lg={2} className={'referralValueCol'}>
                                        <FormControl type={"text"}
                                                     id="resultLastExamination.left.freeVisus"
                                                     value={referral.resultLastExamination.left.freeVisus || ''}
                                                     maxLength={6}
                                                     onChange={handleNumericValueChange}
                                                     disabled={isReadOnly()}
                                        />
                                    </Col>
                                    <Col xs={5} sm={5} md={5} lg={5} className={'borderColumn referralValueCol'}>
                                        <Row className={"ps-2 pe-2"}>
                                            <Col xs={4} sm={4} md={4} lg={4} style={{padding:'1px'}}>
                                                <FormControl type={"text"}
                                                             id="resultLastExamination.left.bestCorrectionSphere"
                                                             value={referral.resultLastExamination.left.bestCorrectionSphere || ''}
                                                             maxLength={6}
                                                             onChange={handleNumericValueChange}
                                                             disabled={isReadOnly()}
                                                />
                                            </Col>
                                            <Col xs={4} sm={4} md={4} lg={4} style={{padding:'1px'}}>
                                                <FormControl type={"text"}
                                                             id="resultLastExamination.left.bestCorrectionCyl"
                                                             value={referral.resultLastExamination.left.bestCorrectionCyl || ''}
                                                             maxLength={6}
                                                             onChange={handleNumericValueChange}
                                                             disabled={isReadOnly()}
                                                />
                                            </Col>
                                            <Col xs={4} sm={4} md={4} lg={4} style={{padding:'1px'}}>
                                                <FormControl type={"text"}
                                                             id="resultLastExamination.left.bestCorrectionAx"
                                                             value={referral.resultLastExamination.left.bestCorrectionAx || ''}
                                                             maxLength={6}
                                                             onChange={handleNumericValueChange}
                                                             disabled={isReadOnly()}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col xs={5} sm={5} md={5} lg={5} className={'borderColumn referralValueCol'}>
                                        <Row className={"ps-2 pe-2"}>
                                            <Col xs={4} sm={4} md={4} lg={4} style={{padding:'1px'}}>
                                                <FormControl type={"text"}
                                                             id="resultLastExamination.left.visus"
                                                             value={referral.resultLastExamination.left.visus || ''}
                                                             maxLength={6}
                                                             onChange={handleNumericValueChange}
                                                             disabled={isReadOnly()}
                                                />
                                            </Col>
                                            <Col xs={4} sm={4} md={4} lg={4} style={{padding:'1px'}}>
                                                <FormControl type={"text"}
                                                             id="resultLastExamination.left.visusAddStph"
                                                             value={referral.resultLastExamination.left.visusAddStph || ''}
                                                             maxLength={6}
                                                             onChange={handleNumericValueChange}
                                                             disabled={isReadOnly()}
                                                />
                                            </Col>
                                            <Col xs={4} sm={4} md={4} lg={4} style={{padding:'1px'}}>
                                                <FormControl type={"text"}
                                                             id="resultLastExamination.left.pressure"
                                                             value={referral.resultLastExamination.left.pressure || ''}
                                                             maxLength={6}
                                                             onChange={handleNumericValueChange}
                                                             disabled={isReadOnly()}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                    </Row>
                                </Col>
                            </Row>

                        </Col>
                            </Row>
                        </Card>
                    </Col>
                    </Row>

                </Col>
                <Col xs={12} sm={12} md={12} lg={3} >
                    <Row>
                        <Col className={"fatBorderColumn"}>
                    <Card bg={"light"} className={"pt-3 ps-4 pe-4"}>
                    <Row className={"senderReceiver"}>
                        <Col xs={6} sm={6} md={5} lg={12}>
                            <p>Remitterande optiker</p>
                            <FormGroup controlId="sender.organizationId">
                                <StyledSelect
                                    value={referral.sender.organizationId || ""}
                                    placeholder="Välj avsändare"
                                    options={(opticianShops || []).map(org => ({value: org.organizationId, label: org.name}))}
                                    onChange={(val) => updateReferralValue('sender.organizationId', val)}
                                    disabled={isReadOnly() || !opticianShops || opticianShops.length === 1}
                                />
                            </FormGroup>
                            {
                                (selectedOpticianShop && <b>{selectedOpticianShop.name}</b>) || <b></b>
                            }
                            {
                                (selectedOpticianShop && <p>{selectedOpticianShop.streetAddress}</p>) || <p></p>
                            }
                            {
                                (selectedOpticianShop && <p>{selectedOpticianShop.zipCode} {selectedOpticianShop.city}</p>) || <p></p>
                            }
                            <FormGroup controlId={"opticianName"}>
                                <StyledSelect
                                    value={referral.opticianName || ''}
                                    placeholder="Välj optiker"
                                    options={
                                        (opticianUsers || [])
                                            .filter(u => !selectedOpticianShop || u.organizationId === selectedOpticianShop.organizationId)
                                            .map(user => {
                                                const fullName = `${user.firstName || ''} ${user.lastName || ''}`.trim() || user.username;
                                                return {value: fullName, label: fullName};
                                            })
                                    }
                                    onChange={(val) => updateReferralValue('opticianName', val)}
                                    disabled={isReadOnly() || (loggedInUser && opticianUsers?.some(u => u.username === loggedInUser))}
                                />
                            </FormGroup>
                        </Col>

                        <Col xs={6} sm={6} md={7} lg={12} xl={12}>
                            <p>Mottagande enhet</p>
                            <FormGroup className={"pb-3"} controlId="receiver.organizationId">
                                <StyledSelect
                                    value={referral.receiver.organizationId || ""}
                                    placeholder="Välj mottagare"
                                    options={availableCareUnits.map(org => ({value: org.organizationId, label: org.name}))}
                                    onChange={(val) => updateReferralValue('receiver.organizationId', val)}
                                    disabled={isReadOnly() || availableCareUnits.length <= 1}
                                />
                            </FormGroup>
                            {
                                (selectedCareUnit && <b>{selectedCareUnit.name}</b>) || <b></b>
                            }
                            {
                                (selectedCareUnit && <p>{selectedCareUnit.streetAddress}</p>) || <p></p>
                            }
                            {
                                (selectedCareUnit && <p>{selectedCareUnit.zipCode} {selectedCareUnit.city}</p>) || <p></p>
                            }
                            <div className={"pb-3"}><b><BsInfoCircleFill/> Info från kliniken</b><br/>
                                <button onClick={()=>openClinicInfoDialog()}><BsBoxArrowUpRight/> Visa info</button></div>
                        </Col>
                    </Row>
                    <Row style={{height:'8px'}}/>
                    </Card>
                    {(!fileURL &&
                        <Row className="justify-content-end justify-content-lg-start g-0">
                            <Col xs={12} sm={5} md={5} className="d-lg-none" />
                            <Col xs={6} sm={3} md={3} lg={12} style={{width: "145px"}}>
                                <Button className={"cancel"} variant="danger" onClick={resetReferralClicked}>Avbryt</Button>
                            </Col>
                            <Col xs={6} sm={3} md={3} lg={12} style={{width: "145px"}}>
                                <Button className={"send"} variant="primary" onClick={sendReferralClicked}>Skicka</Button>
                            </Col>
                        </Row>)
                        ||
                        <Row>
                            <Col xs={5} sm={5} md={5} lg={0} />
                            <Col xs={3} sm={3} md={3} lg={12}>
                                <Button className={"cancel"} variant="danger" onClick={resetReferralClicked}>Rensa</Button>
                            </Col>
                            <Col xs={3} sm={3} md={3} lg={12}>
                                <Button className={"download"} variant="primary" href={fileURL} download={"remiss-"+format(new Date(fileCreatedDate), 'yyyyMMdd-hhmmss')+".pdf"}><BsDownload/> Hämta</Button>
                            </Col>
                        </Row>
                    }
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    </div>
    )}
export default Referral;